import type { Axis, AxisPositions, Positions } from "app/components/RankingAxis/types";
import { FORMATTERS } from "app/common/benchmark/formatters";

export const getAxisPositions = (data: Axis[], format: string, prefix = "", decimal = 0): AxisPositions => {
    if (data?.length) {
        const countsNumbers = data.map(({ absoluteValue }) => absoluteValue);
        const min = Math.min(...countsNumbers);
        const max = Math.max(...countsNumbers);

        const positions: Positions[] = [];

        data.forEach((axis) => {
            positions.push({
                ...axis,
                position: ((axis.absoluteValue - min) / (max - min)) * 100,
            });
        });

        return {
            minDot: {
                count: `${prefix}${FORMATTERS[format](min, decimal)}`,
                position: 0,
            },
            maxDot: {
                count: `${prefix}${FORMATTERS[format](max, decimal)}`,
                position: 100,
            },
            positions,
        };
    }
};
